import React, { useState } from 'react'
import '../../form.css'
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import constant from '../../../../constant';
const Index = ({ state, onChange, onSubmit, addRow, isFinalSubmitting, setIsFinalSubmitting, history }) => {

    return (
        <div className="row">
            <div className="col-md-12 ">
                <div className="appraisal-report-table-responsive">
                    <table
                        className="assessment-table inspn-assessment-table"
                        cellSpacing={0}
                    >
                        <tbody>
                            <tr className="bghed">
                                <td  className="hd-s2 pd10">
                                    {" "}
                                    <p>S.No.</p>
                                </td>
                                <td  className="hd-s2 pd10">
                                    <p>Date</p>
                                </td>
                                <td  className="hd-s2 pd10">
                                    <p>Inspection Area</p>
                                </td>
                                <td  className="hd-s1 pd10">
                                    <p>Inspection Item

                                    </p>
                                </td>
                                <td  className="hd-s1 pd10">
                                    <p>Type of Inspection </p>
                                </td>
                                <td  className="hd-s1 pd10">
                                    <p>Comments & Remark     </p>
                                </td>
                                <td colSpan={3} className="hd-s1 pd10">
                                    <p>Result</p>
                                </td>
                            </tr>

                            {state.map((item, index) => {
                                return (
                                    <tr>
                                        <td className="td-s1">
                                            <p className="s1">{index + 1}.</p>
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="date"
                                                className="form-control"
                                                name={item.date.name}
                                                value={item.date.value}
                                                onChange={(e) => { onChange(item.date.name, e.target.value, index) }}
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Inspection Area"
                                                name={item.inspection_area.name}
                                                value={item.inspection_area.value}
                                                onChange={(e) => { onChange(item.inspection_area.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Inspection Item"
                                                name={item.inspection_item.name}
                                                value={item.inspection_item.value}
                                                onChange={(e) => { onChange(item.inspection_item.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control narrow-date"
                                                placeholder="Enter Type of Inspection"
                                                name={item.type_of_inspection.name}
                                                value={item.type_of_inspection.value}
                                                onChange={(e) => { onChange(item.type_of_inspection.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Comment and Remarks"
                                                name={item.comment_and_remark.name}
                                                value={item.comment_and_remark.value}
                                                onChange={(e) => { onChange(item.comment_and_remark.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control narrow-date"
                                                placeholder="Enter Result"
                                                name={item.result.name}
                                                value={item.result.value}
                                                onChange={(e) => { onChange(item.result.name, e.target.value, index) }}

                                            />
                                        </td>
                                        
                                    </tr>
                                )
                            })}


                            <tr className="addmoreitem">
                                <td className="td-s1" colSpan={15}>
                                    <button type="button" className="btn btn-link" onClick={() => { addRow() }}>
                                        + Add New Block
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="final-checkbox">
                        <div class="form-check">
                            <input class="form-check-input" name="discountCheckbox" type="checkbox" checked={isFinalSubmitting} onChange={() => { setIsFinalSubmitting() }} id="productdiscountCheck1" />
                            <label class="form-check-label" for="productdiscountCheck1">Send to Office for Review</label>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-12 text-left ">
                        <button
                            type='button'
                            className="btn btn-success"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { onSubmit() }}
                        >
                            Submit
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger ms-3"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { history.push(constant.Authedcomponent.production.url) }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Index)